export default (value: number): string => {
  // https://stackoverflow.com/a/2901298/380289
  const formattedValue = Math.round(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `$ ${formattedValue}`;
};
